export const titleRule = {
    ACE: {
        name: 3,
        type: 2,
        specification: 2,
        dosage: 2,
        part: 2,
        remarks: 2
    },
    BD: {
        name: 3,
        specification: 2,
        dosage: 2,
        part: 2,
        remarks: 2
    }
};



// 设置宽度
export const setWdith =  function(num) {
    return `flex-grow: ${num}`;
}

export const tableHeadConfigACE = [
    {
        label: '编号名称',
        type: 'table__name',
    },
    {
        label: '类型',
        type: 'table__type',
    },
    {
        label: '规格',
        type: 'table__specification',
    },
    {
        label: '单件用量',
        type: 'table__dosage',
    },
    {
        label: '欧单单件用量',
        type: 'table__dosage',
        showBrand: '6'
    },
    {
        label: '使用部位',
        type: 'table__part',
    },
    {
        label: '备注',
        type: 'table__remarks',
        wrap:true,
        italyColorLabel:'意大利颜色'
    }
];

export const tableHeadConfigBD = [
    {
        label: '编号名称',
        type: 'table__name',
    },
    {
        label: '规格',
        type: 'table__specification',
    },
    {
        label: '单件用量',
        type: 'table__dosage',
    },
    {
        label: '欧单单件用量',
        type: 'table__dosage',
        showBrand: '6'
    },
    {
        label: '使用部位',
        type: 'table__part',
    },
    {
        label: '备注',
        type: 'table__remarks',
        wrap:true,
        italyColorLabel:'意大利颜色'
    }
]